/* ══════════════════════════════════════════════════════════════
   Trade Log — Sortable Trade History Table
   ══════════════════════════════════════════════════════════════ */

export interface TradeLogEntry {
    entryDate: string;
    exitDate: string;
    strategy: string;
    regime: string;
    entryPrice: number;
    exitPrice: number;
    pnl: number;
    pnlPct: number;
    holdingDays: number;
}

export function renderTradeLog(container: HTMLElement, trades?: TradeLogEntry[]): void {
    const data: TradeLogEntry[] = trades || [
        { entryDate: '2025-01-15', exitDate: '2025-01-22', strategy: 'Momentum Long', regime: 'Bull', entryPrice: 22800, exitPrice: 23150, pnl: 2850, pnlPct: 1.54, holdingDays: 5 },
        { entryDate: '2025-01-27', exitDate: '2025-02-03', strategy: 'Iron Condor', regime: 'Sideways', entryPrice: 23200, exitPrice: 23180, pnl: 1200, pnlPct: 0.52, holdingDays: 5 },
        { entryDate: '2025-02-10', exitDate: '2025-02-14', strategy: 'Momentum Long', regime: 'Bull', entryPrice: 23000, exitPrice: 23400, pnl: 3400, pnlPct: 1.74, holdingDays: 4 },
        { entryDate: '2025-02-20', exitDate: '2025-02-24', strategy: 'Mean Reversion', regime: 'Sideways', entryPrice: 23500, exitPrice: 23350, pnl: -1550, pnlPct: -0.64, holdingDays: 2 },
        { entryDate: '2025-02-26', exitDate: '2025-03-05', strategy: 'Momentum Long', regime: 'Bull', entryPrice: 23100, exitPrice: 23500, pnl: 3200, pnlPct: 1.73, holdingDays: 5 },
    ];

    const rows = data.map((t, i) => `
    <tr style="animation-delay: ${i * 0.03}s">
      <td>${t.entryDate}</td>
      <td>${t.exitDate}</td>
      <td><span class="strategy-tag">${t.strategy}</span></td>
      <td><span class="regime-tag">${t.regime}</span></td>
      <td>₹${t.entryPrice.toLocaleString('en-IN')}</td>
      <td>₹${t.exitPrice.toLocaleString('en-IN')}</td>
      <td class="${t.pnl >= 0 ? 'up' : 'down'}">₹${t.pnl.toLocaleString('en-IN')}</td>
      <td class="${t.pnlPct >= 0 ? 'up' : 'down'}">${t.pnlPct >= 0 ? '+' : ''}${t.pnlPct}%</td>
      <td>${t.holdingDays}d</td>
    </tr>`).join('');

    container.innerHTML = `
    <div class="trade-log glass-card">
      <div class="card-header"><h3>📋 Trade Log</h3><span>${data.length} trades</span></div>
      <div class="table-responsive">
        <table class="trades-table">
          <thead><tr><th>Entry</th><th>Exit</th><th>Strategy</th><th>Regime</th><th>Entry ₹</th><th>Exit ₹</th><th>P&L</th><th>%</th><th>Days</th></tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    </div>`;
}
